require('./bootstrap');

import {createApp, registerRuntimeCompiler} from "vue";
import mitt from 'mitt';
import { VueReCaptcha } from 'vue-recaptcha-v3'
import Popper from "vue3-popper";
import LazyLoad from "vanilla-lazyload";
import { Popover, Carousel } from 'bootstrap';
import { initialiseAnalytics } from './analytics.js';

const analyticsPlugin = initialiseAnalytics();

if (document.getElementById('vue_app')) {
    const emitter = mitt();
    const app = createApp({
        created() {
            let app = document.getElementById('vue_app');
            let pageTakeover = document.getElementsByClassName('page-takeover')[0];

            if(pageTakeover != null) {

                let takeoverUrl = pageTakeover.getAttribute('data-page-takeover-url')
                
                // // Sets the takeover background to be clickable, but only if clicked outside of the header/footer/container elements 
                pageTakeover.addEventListener('click', (event) => {
                    if(event.target == pageTakeover || event.target == app)
                    {
                        if(takeoverUrl != '')
                        {
                            window.open(takeoverUrl, '_blank');
                        }
                    }
                });

                /* Changes the cursor to pointer, to mirror a link hover effect */
                pageTakeover.addEventListener('mousemove', (event) => {
                    if(event.target == pageTakeover || event.target == app) {
                        if(takeoverUrl != '')
                        {
                            pageTakeover.style.cursor = 'pointer';
                        }
                    }
                    else
                    {
                        pageTakeover.style.cursor = 'auto';
                    }
                });
            }
        },
        mounted() {
            init_popover();
            this.updateBrandCount();

            this.emitter.on('initPopovers', data => {
                this.initPopover();
            });
            this.emitter.on('updateSqueezely', data => {
                this.updateSqueezely(data);
            });
        },
        methods: {
            initPopover: function() {
                init_popover()
            },
            initTooltip: function() {
            },
            async updateBrandCount() {
                var brandCountElement = document.getElementById('nav-brand-count');
                var brandCount = '';

                if(brandCountElement) {
                    brandCount = brandCountElement.getAttribute('data-nav-brand-count');
                    
                    if(brandCount == '') {
                        var response = await axios.get('/ajax/get_brand_count');
                        brandCountElement.innerHTML = response.data[0];
                    }
                }

            },
            updateSqueezely(eventObject) {
                window._sqzl = window._sqzl || [];
                window._sqzl.push(eventObject);
            }
        }
    });

    if (analyticsPlugin !== null) {
        app.use(analyticsPlugin);
    }

    if(window.document.querySelector("#contact")) {
        app.use(VueReCaptcha, {
            siteKey: '6LdZYGcrAAAAAG5W4u5nfSWDOvmtlRJJD_yvurvH'
        })
    }

    app.use(Popper);

    //Intercepting axios requests to prepend baseUrl to all requests, for proxy reasons <(^.^)>
    var baseUrlMeta = document.querySelector('meta[name="base_url"]').content.slice(0, -1);

    app.config.compilerOptions.delimiters = ["@{{", "}}"];
    app.config.globalProperties.emitter = emitter;
    app.config.globalProperties.baseUrl = baseUrlMeta;

    axios.interceptors.request.use(function(config) {
        config.url = baseUrlMeta + config.url;
        return config;
    });
    
    // Get all components inside components folder (including subfolders)
    const requireComponent = require.context("./components/", true, /\.vue$/i);

    // Register each base component with their file name as component name.
    requireComponent.keys().map((path) => {
        const component = requireComponent(path);

        // Get name to use for component
        const componentName = path.split("/").pop()?.replace(/\.\w+$/, "");

        app.component(componentName, component.default || component);
    });

    // Get all components inside platform (shared) component folder (including subfolders)
    const requireBackendComponent = require.context("@shared/components/", true, /\.vue$/i);

    // Register each base component with their file name as component name.
    requireBackendComponent.keys().map((path) => {
        const component = requireBackendComponent(path);

        // Get name to use for component
        const componentName = path.split("/").pop()?.replace(/\.\w+$/, "");

        app.component(componentName, component.default || component);
    });

    app.mount("#vue_app");
}

function init_popover() {
    var popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'))
    var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
        return new Popover(popoverTriggerEl)
    })
}

// https://www.andreaverlicchi.eu/vanilla-lazyload/
var lazyLoadInstance = new LazyLoad();
